import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import "react-datepicker/dist/react-datepicker.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import noData from "../../Assets/img/noData.png";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class Results extends Component {
  state = {
    loading: true,
    found: false,
    marks: [],
    subject_list: [],
    gradelist: [],
    show: null,
  };
  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.fetchMarks({
      session: this.props.user.session.id,
      student_class: this.props.user.student_class.id,
      student_section: this.props.user.student_section.id,
      student_info: this.props.user.student_info.id,
    });
  };

  fetchMarks = (params = {}) => {
    axios
      .get(`/api/apptermwisereport`, { params: { ...params } })
      .then((res) => {
        this.setState({
          marks:
            res.data.student_list?.length > 0 ? res.data.student_list[0] : [],
          found: false,
          loading: false,
          subject_list: res.data.subject__list,
          gradelist: res.data.grading_pattern_data,
        });
      })
      .catch((err) => {});
  };

  grade = (percentage) => {
    for (var i = 0; i < this.state.gradelist.length; i++) {
      if (this.state.gradelist[i].min_percentage <= percentage) {
        return this.state.gradelist[i].grade;
      }
    }
    return "NA";
  };

  setId = (id) => {
    if (this.state.show === id) {
      this.setState({ show: 0 });
    } else {
      this.setState({ show: id });
    }
  };

  render() {
    return (
      <div>
        <Header title={`Results`} />
        {this.state.loading ? (
          <div className="container mt-3">
            <Skeleton width={150} />
            <Skeleton count={5} />
          </div>
        ) : this.state.marks?.length === 0 ? (
          <div className="container py-5 text-center th-12">
            <img className="w-100 mt-5" src={noData} alt="No Data Found" />
            <p className="mb-0 th-bold">No Data Avaliable</p>
            <p>Select different month</p>
          </div>
        ) : (
          <div>
            <div className="container">
              {this.state.marks?.student_term_data?.map((term) => {
                return (
                  <>
                    <div className="th-16 th-primary text-center mt-3 pb-2">
                      {term.exam_term__term_name}
                    </div>
                    {term.student_type_data?.map((type) => {
                      var typetotal = 0;
                      var typemmtotal = 0;
                      return (
                        <div className="card p-2 m-2">
                          <div
                            className="th-12 th-primary"
                            onClick={() => {
                              this.setId(type.id);
                            }}
                          >
                            {type.exam_type__exam_type} (MM:{" "}
                            {type.exam_type__max_marks})
                          </div>
                          <table
                            className={`table table-striped th-12 mt-2 ${
                              this.state.show === type.id ? "d-block" : "d-none"
                            }`}
                          >
                            <thead>
                              <tr>
                                <td className="th-medium">Subject</td>
                                <td className="th-medium">Marks</td>
                                <td className="th-medium">Max Marks</td>
                                <td className="th-medium">Grade</td>
                              </tr>
                            </thead>
                            <tbody>
                              {type.marks?.map((marks, index) => {
                                typetotal += marks.marks_obtained;
                                typemmtotal += marks.exam__max_marks;
                                return (
                                  <tr>
                                    <td>
                                      {
                                        this.state.subject_list[index]
                                          .subject__subject
                                      }
                                    </td>
                                    <td>
                                      {marks.marks_obtained === 0
                                        ? marks.attendence
                                          ? 0
                                          : "A"
                                        : marks.marks_obtained}
                                    </td>
                                    <td>{marks.exam__max_marks}</td>
                                    <td>
                                      {this.grade(
                                        (marks.marks_obtained /
                                          type.exam_type__max_marks) *
                                          100
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                              <tr>
                                <td>Total</td>
                                <td>{typetotal}</td>
                                <td>{typemmtotal}</td>
                                <td>
                                  {this.grade((typetotal / typemmtotal) * 100)}
                                </td>
                              </tr>
                              <tr>
                                <td>Percentage</td>
                                <td colspan="3" className="text-center">
                                  {Math.round(
                                    (typetotal /
                                      (type.exam_type__max_marks *
                                        this.state.subject_list.length)) *
                                      100 *
                                      10
                                  ) / 10}
                                  %
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                  </>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps)(Results));
